import { useTheme } from "@mui/material/styles";
import { useHistory, useLocation } from "react-router-dom";
import { Box, Breadcrumbs, Link, NavigateNextIcon } from "../../mui";
import { useSelector } from "react-redux";

const buildBreadCrumb = (path) => {
  const breadCrumbPaths = path.split("/");
  breadCrumbPaths.shift();
  let breadCrumbs = [];
  breadCrumbPaths.forEach((breadCrumb, index) => {
    breadCrumbs.push({
      path: breadCrumbPaths.slice(0, index + 1).join("/"),
      label: breadCrumb,
    });
  });
  return breadCrumbs;
};

const parsePath = (path) => {
  return path.replace(/\/(discover)\//, "");
};

const UIBreadcrumbs = (props) => {
  const location = useLocation();

  const history = useHistory();

  const theme = useTheme();

  const breadCrumbs = buildBreadCrumb(location.pathname);

  const handleBreadCrumbClick = (path) => {
    history.push(`/${path}`);
  };

  const checkNatera = (profile) => {
    if (!profile) return false;
       
    const keys = Object.keys(profile);
    if (keys.some((k) => k.toUpperCase() === "NATERA")) return true;
   
    if (profile.clients_projects) {
      const cpKeys = Object.keys(profile.clients_projects);
      if (cpKeys.some((k) => k.toUpperCase() === "NATERA")) return true;
    }
 
    return false;
  };
 
  const userProfileState = useSelector((state) => state.auth.userProfile);  
  const userProfile = (userProfileState && Object.keys(userProfileState).length > 0)
    ? userProfileState
    : JSON.parse(sessionStorage.getItem("userProfile"));

  const hasNatera = checkNatera(userProfile);
 
  return (
    <Box sx={{ display: "flex", alignItems: "center", mt: "10px" }}>
      <Breadcrumbs
        maxItems={5}
        separator={
          <NavigateNextIcon
            sx={{ color: theme.palette.red.main }}
            fontSize="medium"
          />
        }
      >
        {breadCrumbs.map((breadCrumb) => (
          <Link
            underline="hover"
            key={breadCrumb.path}
            component="button" // Change to button since we're using onClick
            color={
              theme.palette.mode === "light"
                ? theme.palette.black.main
                : "#c9d1d9"
            }
            sx={{
              fontSize: 18,
              cursor: "pointer",
              textTransform: "capitalize",
              background: "none",
              border: "none",
              padding: 0,
              textAlign: "left",
            }}
            onClick={() => handleBreadCrumbClick(breadCrumb.path)}
            onKeyDown={(event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                handleBreadCrumbClick(breadCrumb.path);
              }
            }}
            role="button"
            aria-label={`Navigate to ${breadCrumb.label}`}
          >
            {breadCrumb.label}
          </Link>
        ))}
        {location.pathname === "/home" && hasNatera && (
          <Link
            underline="hover"
            component="button"
            onClick={() => history.push("/home/natera-dashboard")}
            color={
              theme.palette.mode === "light" ? "text.secondary" : "#c9d1d9"
            }
            sx={{
              fontSize: 18,
              cursor: "pointer",
              textTransform: "none",
              background: "none",
              border: "none",
              padding: 0,
            }}
          >
            Natera Dashboard 
          </Link>
        )}
 
      </Breadcrumbs>
    </Box>
  );
};

export default UIBreadcrumbs;
